export function shallowCompare<T extends { [key: string]: any }>(newProps: T, oldProps: T, ignoreProps: string[]) {
  return Object.keys(newProps)
    .filter((x) => ignoreProps.every((i) => i !== x))
    .every((x) => newProps[x] === oldProps[x]);
}
